import React from 'react';
import clsx from 'clsx';
import isNil from 'lodash/isNil';
import range from 'lodash/range';
import {
  useFormContext,
} from 'react-hook-form';
import Controller from 'core/components/FormController';
import IconButton from '@mui/material/IconButton';
import dayjs from 'utils/dayjs';
import PatientHistoryAutoComplete from 'views/EMR/components/PatientHistoryAutoComplete';
import Select from 'core/components/Select';
import ToolTip from 'core/components/Tooltip';
import {
  FieldComponentProps,
} from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import {
  DeleteIcon,
} from 'core/icons';
import Wrapper from 'pages/Dashboard/components/Input/Wrapper';

const currentYear = new Date().getFullYear();
const years = range(currentYear, 1949, -1).map((year) => year.toString());

export default function SurgeryInfo({
  showLabel,
  index,
  onDelete,
  prefix,
}: FieldComponentProps) {
  const dltBtnClasses = clsx({ 'relative top-2': showLabel });
  const { control } = useFormContext();
  const key = `${prefix}.${index}`;

  return (
    <div className="flex items-center gap-4">
      <Controller
        name={`${key}.surgeryName`}
        control={control}
        rules={{ required: true }}
        render={({ field, fieldState: { invalid } }) => (
          <Wrapper
            id="surgicalHistorySettings"
            label={showLabel ? 'Surgeries' : ''}
            className="w-full"
            error={invalid}
            showErrorText={false}
            required={showLabel}
          >
            <PatientHistoryAutoComplete
              {...field}
              id="surgicalHistorySettings"
              keyName="surgeryName"
              placeholder="Surgery"
            />
          </Wrapper>
        )}
      />
      <Controller
        name={`${key}.surgeryYear`}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <Select<string>
            {...field}
            error={!isNil(error)}
            showErrorText={false}
            id="year-option"
            label={showLabel ? 'Year' : ''}
            labelClasses="text-gray-500 text-xs"
            className="min-w-28"
            value={!isNil(field.value) ? dayjs(field.value).get('year').toString() : ''}
            options={years}
            getLabel={(option: string) => option}
            getValue={(option: string) => option}
            placeholder="Select Year"
            onChange={(val: string | string[]) => {
              const date = dayjs(`${val as string}-01-01`);
              field.onChange(date.toISOString());
            }}
          />
        )}
      />
      <ToolTip title="Delete">
        <span>
          <IconButton
            className={dltBtnClasses}
            onClick={() => { onDelete(index); }}
            color="error"
          >
            <DeleteIcon className="text-gray-400 !w-5 !h-5" />
          </IconButton>
        </span>
      </ToolTip>
    </div>
  );
}
